/* Case Study — IntersectionObserver reveal system.
   Adds .is-in-view to .cs-fade-up elements as they enter the viewport.
   Works in every browser. ~35 lines. */
(function () {
  if (!('IntersectionObserver' in window)) {
    // Last-ditch: snap everything visible
    document.querySelectorAll('.cs-fade-up').forEach(function (el) {
      el.classList.add('is-in-view');
    });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-in-view');
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

  function observe() {
    document.querySelectorAll('.cs-fade-up:not(.is-in-view)').forEach(function (el) {
      io.observe(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
